<template>
  <div>
    <v-card class="border-radius-10">
      <v-card-title class="main-gradient">
        <span class="font-weight-black title title-form">Atenção!</span>
      </v-card-title>
      <v-card-text>
        <span class="font-weight-black title title-form">{{ error_message }}</span>
      </v-card-text>
      <v-card-actions>
        <v-layout class="row wrap">
          <v-flex class="s12 justify-flex-end">
            <v-btn class="font-weight-black flex-1 btn-bg-color text-color-white" @click="closeDialog">OK</v-btn>
          </v-flex>
        </v-layout>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'AdminPartnerConfigMessage',
  props: {
    error_message: {
      type: String
    }
  },
  data() {
    return {}
  },
  methods: {
    closeDialog() {
      this.$emit('closeDialog')
    }
  },
  metaInfo: {
    title: "Facilita Pay - Partner Config Form Error Message"
  }
}
</script>

<style scoped>
  .btn-bg-color {
    background-color: var(--secondary-button-background-color) !important;
  }
  .justify-flex-end {
    display: flex;
    justify-items: flex-end;
  }
  .flex-1 {
    flex: 1;
  }
  .text-color-white {
    color: white !important;
  }
  .title-form {
    color: #44517b !important;
  }
</style>



// WEBPACK FOOTER //
// src/AdminPartnerConfigMessage.vue